import SmallTitle from "../../components/shared/SmallTitle";
import Title from "../../components/shared/Title";
import FeatureCard from "./components/FeatureCard";
import "./OurFeatures.scss";

import BlockTrustImg from "../../assets/images/our-features/block-trust.svg";
import FeaderaGuardImg from "../../assets/images/our-features/feadera-guard.svg";
import CloudFusionImg from "../../assets/images/our-features/cloud-fusion.svg";
import BlockchainDriven from "../../assets/images/our-features/blockchain-driven.svg";
import FeaderatedLearning from "../../assets/images/our-features/feaderated-learning.svg";
import HybridCloud from "../../assets/images/our-features/hybrid-cloud.svg";

import ChainImg from "../../assets/images/chain.svg";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrow-down.svg";

import DesktopOval1 from "../../assets/images/decoration/desktop-oval-1.svg";
import OurFeaturesSharpLightsDesktop from "../../assets/images/decoration/our-features-sharp-lights-desktop.svg";

// Feature cards data array
const featuresData = [
	{
		title: "Block Trust",
		description:
			"ChainCompute Al leverages blockchain to create a secure, transparent, and decentralized environment for Al computation. With immutable ledgers and smart contracts, it ensures trust, data integrity, and scalable, automated operations.",
		image: BlockTrustImg,
	},
	{
		title: "Feadera Guard",
		description:
			"ChainCompute Al uses federated learning to train models while keeping data on users' devices,ensuring privacy and regulatory compliance. It enables secure, cross-industry collaboration through encrypted model updates without exposing sensitive data.",
		image: FeaderaGuardImg,
	},
	{
		title: "Cloud Fusion",
		description:
			"ChainCompute Al uses hybrid cloud infrastructure, combining public and private clouds for scalable, secure, and cost-effective AI workloads. This ensures optimal performance while protecting sensitive data and optimizing resource usage.",
		image: CloudFusionImg,
	},
	{
		title: "Blockchain-Driven Trust & Security ",
		description:
			"ChainCompute Al uses blockchain for a secure, transparent system with verifiable, tamper-proof actions. Users eam rewards by contributing computing power, without relying on a central authority.",
		image: BlockchainDriven,
	},
	{
		title: "Feaderated Learning ",
		description:
			"ChainCompute AI uses federated learning to train models while keeping data on your device, ensuring privacy. It enables secure collaboration across industries without sharing sensitive information.",
		image: FeaderatedLearning,
	},
	{
		title: "Hybrid Cloud",
		description:
			"ChainCompute Al integrates public and private cloud resources, enabling seamless scalability and efficient handling of Al workloads while optimizing costs for users.",
		image: HybridCloud,
	},
];

export default function OurFeatures() {
	return (
		<>
			<div className="our-features" id="our-features">
				<div className="our-features-content-wrapper content-wrapper-lg">
					<img
						className="decoration light desktop-light-1"
						src={DesktopOval1}
						alt="decorative-img"
					/>
					<img
						className="decoration light sharp-lights"
						src={OurFeaturesSharpLightsDesktop}
						alt="decorative-img"
					/>

					<div className="our-features-content">
						<div className="our-features-chain" data-aos="fade-left">
							<img
							className="decoration shake-slow-2"
								src={ChainImg}
								alt="Chain"
							/>
						</div>

						<SmallTitle className="our-features-small-title" data-aos="fade-up">
							Navigate Decentralization
						</SmallTitle>

						<Title className="our-features-title" data-aos="fade-up" data-aos-delay="100">
							Simplifying the Decentralized World, One Insight at
							a Time.
						</Title>
					</div>

					<ul className="our-features-list">
						{featuresData.map((feature) => (
							<li
								className="our-features-item"
								key={feature.title}
								data-aos="zoom-in"
							>
								<FeatureCard className="our-features-card">
									<div className="feature-card-img">
										<img
											src={feature.image}
											alt={`${feature.title} Icon`}
										/>
									</div>

									<h4 className="feature-card-title">
										{feature.title}
									</h4>

									<p className="feature-card-desc">
										{feature.description}
									</p>
								</FeatureCard>

								<ArrowDown className="feature-card-arrow" />
							</li>
						))}
					</ul>
				</div>
			</div>
		</>
	);
}
